/**
 * @param { Object } meta
 * @return { Object }
 */
export const transformPagination = (meta = {}) => {
  const pagination = meta.pagination || {}

  return {
    currentPage: pagination.currentPage,
    totalRows: pagination.total,
    perPage: pagination.perPage,
  }
}



// WEBPACK FOOTER //
// ./src/transform/pagination.js